module.exports = __webpack_public_path__ + "static/media/Ellipse.007bd134.png";